const portfolioState  = {
    loader : false,
    portfolioSuccessMessage: "",
    portfolioErrorMessage: "",
    allportfolios: [],
    parPage: 0,
    portfolioCount: 0,
    singlePortfolio:''

 
  };
  
  export const portfolioReducer = (state = portfolioState, action) => {
    const { payload, type } = action;
  
      if(type === "PORTFOLIO_SET_LOADER"){
        return {
          ...state,
          loader : true
      }
      }
      if(type === 'DHASBOARD_PORTFOLIO_ADD_SUCCESS'){
        return {
            ...state,
            loader : false,
            portfolioSuccessMessage : payload.successMessage,
            portfolioErrorMessage : ''
        }
    }
    if(type === 'DHASBOARD_PORTFOLIO_ADD_FAIL'){
      return {
        ...state,
        loader : false,
        portfolioErrorMessage : payload,
        portfolioSuccessMessage : ''
      }
  }
  
    if (type === "PERPAGE_PORTFOLIO_GET_SUCCESS") {
      return {
        ...state,
        allportfolios: payload.allPortfolio,
        portfolioCount: payload.portfolioCount,
        parPage: payload.parPage,
      };
    }
    if (type === "ALL_PORTFOLIO_GET_SUCCESS") {
      return {
        ...state,
        allportfolios: payload.getPortfolio
       
      };
    }
  

    if (type === "PORTFOLIO_DELETE_SUCCESS") {
      return {
        ...state,
        portfolioSuccessMessage: payload,
        portfolioErrorMessage : ''
      };
    }
   if(type === "SINGLE_PORTFOLIO_GET_SUCCESS"){
    return {
      ...state,
      singlePortfolio: payload.singlePortfolio
    };
   }
  
    return state;
  };
  